import { Directive, Input, OnChanges, SimpleChanges, OnInit, OnDestroy, SimpleChange, model } from '@angular/core';
import { TypeaheadDirective, TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { isObservable, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * This is a patch for the typeahead to prevent XSS issues.
 */
@Directive({
    selector: '[wsTypeahead]',
})
export class WsTypeaheadDirective extends TypeaheadDirective implements OnInit, OnChanges, OnDestroy {
    @Input() wsTypeahead: Observable<any[]> | any[];

    override typeahead = model<TypeaheadMatch[] | Observable<TypeaheadMatch[]> | undefined>(undefined);
    override typeaheadPhraseDelimiters = model<string>('');

    ngOnInit(): void {
        super.ngOnInit();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.wsTypeahead) {
            const dataSource: SimpleChange = changes.wsTypeahead;
            if (dataSource.currentValue) {
                const value = dataSource.currentValue;
                if (isObservable(value)) {
                    this.typeahead.set(value.pipe(
                        map((item) =>
                            Array.isArray(item) ? item.map((x) => this._sanitizeItem(x)) : this._sanitizeItem(item),
                        ),
                    ));
                } else {
                    this.typeahead.set((value as any[]).map((x) => this._sanitizeItem(x)));
                }
            } else {
                this.typeahead.set([]);
            }
        }
    }

    testMatch(match: string, test) {
        let spaceLength;
        if (typeof test === 'object') {
            spaceLength = test.length;
            for (let i = 0; i < spaceLength; i += 1) {
                if (test[i].length > 0 && this._escapeHtml(match).indexOf(this._escapeHtml(test[i])) < 0) {
                    return false;
                }
            }
            return true;
        }
        return this._escapeHtml(match).indexOf(this._escapeHtml(test)) >= 0;
    }

    private _sanitizeItem(item: any): any {
        const field = this.typeaheadOptionField();
        if (field) {
            item[field] = this._removeHtmlTags(item[field]);
        } else if (typeof item === 'string') {
            return this._removeHtmlTags(item);
        }
        return item;
    }

    private _removeHtmlTags(unsafe: string): string {
        if (!unsafe) {
            return unsafe;
        }
        return unsafe.replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    private _escapeHtml(unsafe: string): string {
        if (!unsafe) {
            return unsafe;
        }
        return unsafe.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
    }
}
